import { render, staticRenderFns } from "./index.vue?vue&type=template&id=e1bf9124&"
import script from "./index.vue?vue&type=script&setup=true&lang=ts&"
export * from "./index.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e1bf9124')) {
      api.createRecord('e1bf9124', component.options)
    } else {
      api.reload('e1bf9124', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=e1bf9124&", function () {
      api.rerender('e1bf9124', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/[town-translit]/diagnostika/analiz/index.vue"
export default component.exports